/* eslint-disable */
import * as Types from './types';

import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { fetcher } from '../../fetcher';
export type GetCollectionQueryVariables = Types.Exact<{
  handle: Types.Scalars['String'];
  country: Types.CountryCode;
  language: Types.LanguageCode;
}>;


export type GetCollectionQuery = { __typename?: 'QueryRoot', collection?: { __typename?: 'Collection', id: string, title: string, seo: { __typename?: 'SEO', title?: string | null, description?: string | null } } | null };

export declare const getCollection: import("graphql").DocumentNode;

export const GetCollectionDocument = /*#__PURE__*/ `
    query getCollection($handle: String!, $country: CountryCode!, $language: LanguageCode!) @inContext(country: $country, language: $language) {
  collection(handle: $handle) {
    id
    title
    seo {
      title
      description
    }
  }
}
    `;
export const useGetCollectionQuery = <
      TData = GetCollectionQuery,
      TError = unknown
    >(
      dataSource: { endpoint: string, fetchParams?: RequestInit },
      variables: GetCollectionQueryVariables,
      options?: UseQueryOptions<GetCollectionQuery, TError, TData>
    ) =>
    useQuery<GetCollectionQuery, TError, TData>(
      ['getCollection', variables],
      fetcher<GetCollectionQuery, GetCollectionQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, GetCollectionDocument, variables, options),
      options
    );

useGetCollectionQuery.getKey = (variables: GetCollectionQueryVariables) => ['getCollection', variables];
;

useGetCollectionQuery.fetcher = (dataSource: { endpoint: string, fetchParams?: RequestInit }, variables: GetCollectionQueryVariables, options?: RequestInit['headers']) => fetcher<GetCollectionQuery, GetCollectionQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, GetCollectionDocument, variables, options);